import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { alertActions, breadcrumbsActions, specialitiesActions as myActions, masterProfilesActions } from "../../../_services/essentials/store";

import Grid from "@mui/material/Grid2";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Pagination from '@mui/material/Pagination';
import { history } from "../../../_services/essentials/helpers";
import { IconButton, Avatar, Tooltip, } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";

import CircularProgress from '@mui/material/CircularProgress';
import {NoRecordsFound} from "../../../_components/NoRecordsFound";
export { SpecialityList };

function SpecialityList() {
    const entities_label = "DOL Dedicated";

    const loggedInUser = useSelector(x => x.auth.loggedInUser);
    const listAPIResponse = useSelector(x => x.specialities?.listAPIResponse);
    const [loading, setLoading] = useState(true);
    const [entities, setEntities] = useState([]);
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [onLoadWait, setOnLoadWait] = useState(true);

    useEffect(() => {
        if (
            listAPIResponse &&
            listAPIResponse.value &&
            Array.isArray(listAPIResponse.value.list)) {
            setEntities(listAPIResponse?.value?.list);
            setTotalPages(listAPIResponse?.value?.totalPages);
            setTotalItems(listAPIResponse?.value?.totalItems);

            setLoading(false);
        }
    }, [listAPIResponse]);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        description: Yup.string()
            .trim()
            .required('Required*')
            .max(250, 'Cannot exceed 250 characters'),
        geographicScope: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        keywordOrTherapeuticArea: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
    });

    const formOptions = { resolver: yupResolver(validationSchema) };

    const { register, handleSubmit, reset, formState } = useForm(formOptions);

    const { errors } = formState;

    const [dataFilter, setDataFilter] = useState({
        "userProjectFilter": {
            activeStatusGroupFlag: true,
            userId: loggedInUser?.id,
            searchTerms: ""
        }
    });

    const [pageFilter, setPageFilter] = useState({
        "pageNumber": 1,
        "pageSize": 100000,
        "sortField": "status.sortOrder, lastUpdatedTime",
        "sortDirection": "asc, desc",
        "dataFilter": dataFilter
    });

    const memoizedPageFilter = useMemo(() => {
        return {
            ...pageFilter,
            dataFilter: {
                ...dataFilter,
            },
        };
    }, [dataFilter]);

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    useEffect(() => {
        setDataFilter({
            "userProjectFilter": {
                activeStatusGroupFlag: true,
                userId: loggedInUser?.id,
                searchTerms: ""
            }
        });
    }, [loggedInUser]);

    useEffect(() => {
        if(!onLoadWait) {
            dispatch(breadcrumbsActions.setCurrentTitle(entities_label));
            dispatch(myActions.getPaginatedList(memoizedPageFilter));
        }
    }, [pageFilter, onLoadWait ]);

    useEffect(() => {
        if(!onLoadWait) {
            dispatch(breadcrumbsActions.setCurrentTitle(entities_label));
            dispatch(myActions.getPaginatedList(memoizedPageFilter));
        }
    }, [pageFilter, onLoadWait ]);

    useEffect(() => {
        if(onLoadWait){
            const timeoutId = setTimeout(() => {
                setOnLoadWait(false);
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [onLoadWait]);

    function navigatePage(event, newPageNumber) {
        setPageFilter({
            ...pageFilter,
            "pageNumber": newPageNumber
        });
    }

    function showProjectProfiles(selectedUserProject) {
        //history.navigate(`/master_profiles?project_id=${selectedProjectId}`);
        //history.navigate(`/master_profiles?user_projects=true`, { state: { selectedUserProject } });
        history.navigate(`/dol_profiles?user_projects=true`, { state: { selectedUserProject } });

    }

    function CustomTabPanel(props) {
        const { children, value, backgroundColor, index, ...other } = props;

        return (
            <Box
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                minHeight={'200px'}
                sx={{ flexDirection: 'row', mb: 3 }}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index &&
                    <Stack direction="column" sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        {children}
                    </Stack>
                }
            </Box>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    async function downloadprofiles(event, projectId, projectName) {
        const dataFilter = {
            "masterProfileFilter": {
                projectId: projectId,
                userId: loggedInUser?.id,
                searchTerms: ""
            }
        };
        const pageFilter = {
            "pageNumber": 1,
            "pageSize": 100000, //TODO: Move this to env
            "sortField": "ranking",
            "sortDirection": "asc",
            "dataFilter": dataFilter,
            "projectName": projectName
        };

        await dispatch(masterProfilesActions.downloadprofilesByFilter(pageFilter)).unwrap();
        dispatch(myActions.getAll());
    }

    const containerRef = useRef(null);
    const [gridSpacing, setGridSpacing] = useState(2);

    useEffect(() => {
        const container = containerRef.current;

        if (container) {
            const observer = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    const { width } = entry.contentRect;
                    if (width >= 1350) {
                        setGridSpacing(2);
                    } else if (width >= 1200) {
                        setGridSpacing(6.5);
                    } else {
                        setGridSpacing(6);
                    }
                }
            });

            observer.observe(container);

            return () => observer.disconnect();
        }
    }, []);

    return (
        <Box sx={{ width: '99%', maxWidth: { sm: '100%', md: '100%' }, ml: 2 }} ref={containerRef}>
            {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                {entities_label}
            </Typography> */}
            <Stack direction="row"
                sx={{ width: '100%', justifyContent: 'space-between', flexGrow: '1', gap: 1, pt: 2, pb: 2, mb: 2, border: '1px solid #E0E0E066' }} spacing={3}>
                {/* <Stack sx={{ pl: 4, width: '100%' }}>
                    <Search control={control} sx={{ width: '350px' }} handleSubmit={handleSubmit}

                    />
                </Stack> */}
                <Stack direction="row" spacing={2} sx={{ mb: 1, mt: 0.5, width: '100%', justifyContent: 'right' }} >

                    {/*<Button onClick={() => handleCreateProjectPopupOpen()}*/}
                    {/*    variant="contained" color="primary" size="small"*/}
                    {/*    endIcon={<AddIcon />}>*/}
                    {/*    Create Project*/}
                    {/*</Button>*/}
                    <Stack direction="row" sx={{ ml: 5, justifyContent: 'center', alignItems: 'center' }}>
                        <Avatar
                            sx={{
                                height: 24,
                                backgroundColor: '#666fff',
                                color: '#FFF',
                                fontSize: '13px', fontWeight: 600
                            }}
                        >
                            {totalItems ? totalItems.toLocaleString() : 0}
                        </Avatar>
                        <Typography variant="body1" sx={{ ml: 0.5, mr: 1, fontWeight: 600 }}> DOLs
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
            {loading ? (<div
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    height: '80%'
                    // zIndex: 1,
                }}
            >
                <CircularProgress />
            </div>) : (
                <Grid container spacing={1} columns={12}>
                    <Grid size={{ md: 12, lg: 12 }}>
                        <Grid
                            container
                            spacing={2}
                            columnSpacing={gridSpacing}
                            rowSpacing={3}
                            columns={12}
                            sx={{ mb: (theme) => theme.spacing(1), flexGrow: 1, flexWrap: 'wrap' }}
                        >
                            {(entities?.length > 0) && entities?.map((entity, index) => (
                                <Stack direction="row" sx={{ ml: 8, justifyContent: 'center', alignItems: 'center', height: '120px', border:1 }}>
                                    <Stack direction="row" sx={{justifyContent: 'center', alignItems: 'center' }}>
                                        <Box sx={{
                                            pointerEvents: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'none' : 'auto',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                             onClick={() => showProjectProfiles(entity)}>
                                            <img
                                                src={`${entity.image_url}`}
                                                alt="Project" loading="lazy"
                                                className="app-user-projects-logo"
                                                style={{ height: '120px', width: '160px' }}
                                            />
                                            {/* {(Date(entity.lastUpdatedTime).toLocaleString()
                                                        .toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })).substring(0, 25)} */}

                                            {/*className="app-user-projects-logo"*/}
                                            {/*/resources/assets/images/projects/1.png*/}
                                        </Box>
                                    </Stack>
                                    <Stack sx={{minWidth: '300px', height: '120px' }}>
                                <Grid key={index} item
                                    //  size={{ xs: 6, sm: 6, lg: 6 }}
                                      sx={{
                                          flexBasis: '265px',
                                          flexGrow: 1,
                                          border:1
                                      }}>
                                    <Card
                                        variant="outlined" sx={{
                                        // height: '100%',
                                        //  flexGrow: 0.5,
                                        // background: 'linear-gradient(to top, #9cb0f2, #d5e2ed 200px)',
                                        // background: 'linear-gradient(to top, #d5e2ed, #9cb0f2 200px)',
                                        border: '1px solid rgba(79, 70, 229, 0.20)',
                                        backdropFilter: 'blur(1px)',
                                        borderRadius: '5px',
                                        p: 0,
                                        transition: "transform .3s ease, box-shadow .3s ease",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                            transform: "translateY(-2px)",
                                            boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.3)",
                                            "& .corner-value": {
                                                visibility: 'visible',
                                                opacity: 1,
                                            }
                                        },

                                        // opacity: (entity.status?.isActive === 0) ? 0.6 : 1,
                                    }}
                                    >
                                        <Tooltip title={entity.totalProfilesAdded === 0 ? "No DOL found" : null}>
                                            <Stack direction="row" sx={{
                                                flexGrow: '1', gap: 1,
                                                backgroundColor: (entity.status?.isActive === 0) ? 'grey.500' : 'background.paper',
                                                mb: 1
                                            }}>
                                                <Box
                                                    sx={{
                                                        cursor: 'pointer', width: '100%',
                                                        pointerEvents: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'none' : 'auto'
                                                    }}
                                                    onClick={() => showProjectProfiles(entity)}>
                                                    <Typography
                                                        // component="h2" variant="subtitle1" gutterBottom>
                                                        variant="body1" component="div" sx={{
                                                        fontWeight: '600',
                                                        // m: 2,
                                                        mt: 1,
                                                        mb: 1,
                                                        ml: 2,
                                                        mr: 2,
                                                        color: '#FFF'
                                                    }}>
                                                        {entity.name}
                                                    </Typography>

                                                    {/* {entity.totalProfilesAdded === 0 && <Tooltip title="No KOL found">} */}
                                                    {/* <Stack
                                                direction="column"
                                                sx={{ flexGrow: '1', gap: 1 }}
                                            > */}
                                                </Box>
                                            </Stack>
                                        </Tooltip>
                                            <CardContent>

                                                <Tooltip title={entity.totalProfilesAdded === 0 ? "No DOL found" : null}>
                                                    <Box sx={{
                                                        pl: 2,
                                                        pr: 2,
                                                        cursor: 'pointer',
                                                        pointerEvents: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'none' : 'auto',
                                                    }}
                                                         onClick={() => showProjectProfiles(entity)}>
                                                        <Stack direction="row" sx={{
                                                            flexGrow: '1',
                                                            gap: 1,
                                                            justifyContent: 'space-between'
                                                        }}>
                                                            {/* <Stack
                                                        direction="row"
                                                    // divider={<Divider orientation="vertical" color={'blue'} />}
                                                    > */}
                                                            <Stack direction="column" sx={{}}>
                                                                {/*<Stack sx={{ justifyContent: 'space-between' }}>*/}
                                                                <Typography component="h2" variant="subtitle2">
                                                                    <span style={{fontWeight: '600'}}>Total Profiles:</span>
                                                                    <span style={{
                                                                        marginLeft: '4px',
                                                                        fontWeight: '400',
                                                                        // color: '#8E8E8E'
                                                                    }}>{entity.totalProfilesAdded}</span>
                                                                </Typography>
                                                            </Stack>
                                                            {/*<Stack direction="column" sx={{}}>*/}
                                                            {/*    <Typography component="h2" variant="subtitle2" sx={{}}>*/}
                                                            {/*        <span style={{fontWeight: '600'}}>Project ID:</span>*/}
                                                            {/*        <span style={{*/}
                                                            {/*            marginLeft: '4px',*/}
                                                            {/*            fontWeight: '400'*/}
                                                            {/*        }}>{entity.id}</span>*/}
                                                            {/*    </Typography>*/}
                                                            {/*</Stack>*/}
                                                        {/*<Stack direction="row">*/}
                                                        {/*    <Stack>*/}
                                                        {/*        <Typography component="h2" variant="subtitle2"*/}
                                                        {/*                    sx={{fontWeight: 600}}>*/}
                                                        {/*            Project Description :*/}
                                                        {/*        </Typography>*/}
                                                        {/*        <Typography component="h2" variant="subtitle2"*/}
                                                        {/*                    sx={{fontWeight: 400}}>*/}
                                                        {/*            {entity.description}*/}
                                                        {/*        </Typography>*/}
                                                        {/*    </Stack>*/}
                                                        {/*</Stack>*/}
                                                        {/*<Stack direction="row">*/}
                                                        {/*    <Stack>*/}
                                                        {/*        <Typography component="h2" variant="subtitle2"*/}
                                                        {/*                    sx={{fontWeight: 600}}>*/}
                                                        {/*            Service Provided:*/}
                                                        {/*        </Typography>*/}
                                                        {/*        <Typography component="h2" variant="subtitle2"*/}
                                                        {/*                    sx={{fontWeight: 400}}>*/}
                                                        {/*            {entity.type?.name}*/}
                                                        {/*        </Typography>*/}
                                                        {/*    </Stack>*/}
                                                        {/*</Stack>*/}
                                                        {/*<Stack direction="row">*/}
                                                        {/*    <Stack>*/}
                                                        {/*        <Typography component="h2" variant="subtitle2"*/}
                                                        {/*                    sx={{fontWeight: 600}}>*/}
                                                        {/*            Specialty :*/}
                                                        {/*        </Typography>*/}
                                                        {/*        <Typography component="h2" variant="subtitle2"*/}
                                                        {/*                    sx={{fontWeight: 400}}>*/}
                                                        {/*            {entity.keywordOrTherapeuticArea}*/}
                                                        {/*        </Typography>*/}
                                                        {/*    </Stack>*/}
                                                        {/*</Stack>*/}
                                                        {/*<Stack direction="row" sx={{pb: 1, borderBottom: '1px solid grey'}}>*/}
                                                        {/*    <Stack>*/}
                                                        {/*        <Typography component="h2" variant="subtitle2"*/}
                                                        {/*                    sx={{fontWeight: 600}}>*/}
                                                        {/*            Geography :*/}
                                                        {/*        </Typography>*/}
                                                        {/*        <Typography component="h2" variant="subtitle2"*/}
                                                        {/*                    sx={{fontWeight: 400}}>*/}
                                                        {/*            {entity.geographicScope}*/}
                                                        {/*        </Typography>*/}
                                                        {/*    </Stack>*/}
                                                        {/*</Stack>*/}
                                                        </Stack>
                                                    </Box>
                                                </Tooltip>
                                                <Stack
                                                    direction="row"
                                                    sx={{pointerEvents: 'auto',}}>
                                                    <Box
                                                        sx={{
                                                            position: 'absolute',
                                                            bottom: 4,
                                                            left: 20,
                                                            color: (entity?.status?.id === 1) ? "#008000" : (entity?.status?.id === 5) ? "#808b96" : "#0c87be",
                                                            fontSize: '10px',
                                                            transition: 'visibility 0s, opacity 0.2s ease-in-out',
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                        <CircleRoundedIcon sx={{mb: 0.5, fontSize: '10px'}}/>
                                                        <span style={{
                                                            paddingLeft: '4px',
                                                            paddingTop: '4px',
                                                            fontSize: '12px',
                                                            mt: .5
                                                        }}>{entity.status?.name} </span>
                                                    </Box>
                                                </Stack>
                                                    {/*<Stack*/}
                                                    {/*    direction="row"*/}
                                                    {/*    sx={{pointerEvents: 'auto',}}>*/}
                                                    {/*    <Link*/}
                                                    {/*        // onClick={() => showProjectProfiles(entity)}*/}
                                                    {/*        onClick={() =>*/}
                                                    {/*            history.navigate(`/user_projects/edit/${entity.id}`)*/}
                                                    {/*        }*/}
                                                    {/*        variant="body2"*/}
                                                    {/*        sx={{*/}
                                                    {/*            alignSelf: 'center', cursor: 'pointer',*/}
                                                    {/*            textDecoration: "none",*/}
                                                    {/*            color: 'background.paper'*/}
                                                    {/*        }}*/}
                                                    {/*    >*/}
                                                    {/*        Edit Project*/}
                                                    {/*        <ArrowCircleRightOutlinedIcon*/}
                                                    {/*            sx={{color: 'background.paper', ml: 1}}/>*/}
                                                    {/*    </Link>*/}
                                                    {/*</Stack>*/}
                                                    <Tooltip
                                                        title={entity.totalProfilesAdded === 0 ? "No KOL found" : null}>
                                                        <Stack
                                                            direction="row">
                                                            <IconButton
                                                                color="inherit"
                                                                sx={{
                                                                    border: "none",
                                                                    pointerEvents: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'none' : 'auto',
                                                                }}
                                                                onClick={(e) => {
                                                                    downloadprofiles(e, entity.id, entity.name)
                                                                }}
                                                            >
                                                                {/*<FileDownloadOutlinedIcon*/}
                                                                {/*    sx={{color: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'grey.500' : '#4F46E5'}}/>*/}
                                                            </IconButton>
                                                        </Stack>
                                                    </Tooltip>
                                                    {/*<Box*/}
                                                    {/*    sx={{*/}
                                                    {/*        position: 'absolute',*/}
                                                    {/*        bottom: 4,*/}
                                                    {/*        right: 2,*/}
                                                    {/*        color: 'background.paper',*/}
                                                    {/*        fontSize: '10px',*/}
                                                    {/*        // visibility: 'hidden',*/}
                                                    {/*        // opacity: 0,*/}
                                                    {/*        // transition: 'visibility 0s, opacity 0.2s ease-in-out',*/}
                                                    {/*        zIndex: 1,*/}
                                                    {/*        pr: '2px'*/}
                                                    {/*    }}*/}
                                                    {/*    // className="corner-value"*/}
                                                    {/*>*/}
                                                    {/*    <strong>Last Updated :</strong>*/}
                                                    {/*    {moment(entity.lastUpdatedTime).format('DD-MM-YYYY')}*/}

                                                    {/*    /!* {(Date(entity.lastUpdatedTime).toLocaleString()*/}
                                                    {/*        .toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })).substring(0, 25)} *!/*/}
                                                    {/*</Box>*/}
                                            </CardContent>
                                            </Card>
                                    </Grid>
                                </Stack>
                            </Stack>
                            ))}
                            {(entities?.length === 0) &&
                                <NoRecordsFound message={"No project has been created yet."}/>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            )
            }
            {
                (totalPages > 1) &&
                <Pagination variant="outlined" color="primary" count={totalPages} page={pageFilter.pageNumber} onChange={navigatePage} />
            }

        </Box >
    );
}
